export default __webpack_public_path__ + "dde43d81c17d5634a6bbcaa7de33be0b.pdf";